import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Cache } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { PORTAL_ADMIN, PROJECT_ADMIN } from '../../../store/actions/users/usersActions';
import { handleInputChange, 
  resetActivity, 
  upsertActivity, 
  getActivity } from '../../../store/actions/activities/activitiesActions';

import PageTitle from '../../../common/PageTitle';

class ActivityForm extends Component {
  constructor(props) {
    super(props);

    this.submitButtonText = 'Submit';
    this.action = '';
    this.addActivity = 'ADD_ACTIVITY';
    this.updateActivity = 'UPDATE_ACTIVITY';

    this.pathname = this.props.location.pathname;
    this.roleId = Cache.getItem('roleId');
  }

  componentDidMount() {
    if (this.roleId === PORTAL_ADMIN || this.roleId === PROJECT_ADMIN) {

      if (this.pathname === '/settings/tasks/update') {
        const urlParams = new URLSearchParams(this.props.location.search);
        const activityCode =  urlParams.get('code');
        this.props.getActivity(activityCode);
        this.submitButtonText = 'Update';
        this.action = 'UPDATE_ACTIVITY';
      }
    }
    else {
      this.props.history.push('/dashboard');
    }
  }

  componentWillUnmount() {
    this.props.resetActivity();
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const submitButton = document.querySelector("button[type='submit']");
    submitButton.disabled = true;
    if (this.submitButtonText === 'Submit') {
      submitButton.textContent = "Submitting...";
    }
    else {
      submitButton.textContent = "Updating...";
    } 
    
    this.props.upsertActivity(this.action, () => {
      this.props.history.push('/settings/tasks');
    })

    submitButton.disabled = false;
    if (this.submitButtonText === 'Submit') {
      submitButton.textContent = "Submitted!";
    }
    else {
      submitButton.textContent = "Updated!";
    }

    setTimeout(() => {  
      submitButton.textContent = this.submitButtonText;
    }, 1000);
  }

  render() {
    let formTitle = '';

    if (this.pathname === '/settings/tasks/update') {
      this.submitButtonText = 'Update';
      formTitle = 'Update Task';
      this.action = this.updateActivity;
    }
    else {
      formTitle = 'Add Task';
      this.action = this.addActivity;
    }

    
    const activity = this.props.activities.activity;

    let activityName = '';
    let activityCode = '';
    let templateCode = '';
    let activityFrequency = '';


    if (Object.keys(activity).length) {
      activityName = activity.name;
      activityCode = activity.activity_code;
      templateCode = activity.template_code;
      activityFrequency = activity.frequency;
    }

    return (
      <>
        <PageTitle pageName={formTitle}  />
        <Form className="mt-3" onSubmit={this.handleSubmit}>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="name">
                <Form.Label>Task Name<span className='required-field'> * </span></Form.Label>
                <Form.Control 
                  type="text" 
                  value={activityName} 
                  onChange={this.props.handleInputChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="activity_code">
                <Form.Label>Task Code<span className='required-field'> * </span></Form.Label>
                <Form.Control 
                  type="text" 
                  value={activityCode}
                  onChange={this.props.handleInputChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="template_code">
                <Form.Label>Template Code<span className='required-field'> * </span></Form.Label>
                <Form.Control 
                  type="text" 
                  value={templateCode}
                  onChange={this.props.handleInputChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="frequency">
                <Form.Label>Frequency<span className='required-field'> * </span></Form.Label>
                <Form.Control 
                  type="text" 
                  value={activityFrequency}
                  onChange={this.props.handleInputChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>  
              <div className="float-right">
                <Button variant="default" onClick={() => {
                    this.props.history.push('/settings/tasks');
                  }}>Cancel</Button> 
                <Button variant="primary" type="submit">{this.submitButtonText}</Button>
              </div>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export const mapStateToProps = (state) => ({
  activities: state.activities
})

export const mapDispatchToProps = (dispatch) => ({
  handleInputChange: (...args) => dispatch(handleInputChange(...args)),
  resetActivity: () => dispatch(resetActivity()),
  upsertActivity: (...args) => dispatch(upsertActivity(...args)),
  getActivity: (...args) => dispatch(getActivity(...args))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivityForm))
